import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "stores";
import { setLanguage } from "stores/i18n";
import { FormattedMessage } from "react-intl";
import {NavLink, RouteComponentProps, withRouter} from "react-router-dom";
import { NavigationLink } from "types";
import * as styles from "./styles";
import logout from "../../helpers/logout";
import {ListviewIcon} from "../../assets/icons/listview";

interface IProps {
  links: NavigationLink[];
  locale: string;
  setLanguage: (language: string) => void;
  authed: boolean;
}

interface IState {
  open: boolean;
}

class Menu extends React.Component<IProps & RouteComponentProps, IState> {
  state = {
    open: false
  };

  render() {
    return (
      <div className={styles.menu}>
        <div
          className={styles.menuButton}
          onClick={() => this.setState({ open: !this.state.open })}
        >
          <div>
            <FormattedMessage id="components.Menu.Menu" />
          </div>
          <ListviewIcon color={"black"} size={22} />
        </div>
        <div
          className={`${styles.menuItems} ${
            this.state.open ? styles.open : styles.closed
          }`}
        >
          {this.props.authed &&
            this.props.links.map(link => (
              <NavLink
                key={link.to}
                exact={link.exactMatch}
                to={link.to}
                onClick={() => this.setState({ open: false })}
              >
                {link.text}
              </NavLink>
            ))}

          <div className={styles.bottomLinks}>
            <div
              onClick={() => {
                this.props.setLanguage(
                  this.props.locale === "en" ? "nb" : "en"
                );
                this.setState({ open: false });
              }}
            >
              {this.props.locale === "en"
                ? "Bytt til norsk"
                : "Switch to english"}
            </div>
            {this.props.authed && (
              <div onClick={logout}>
                <FormattedMessage id="components.Header.logout" />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    locale: state.i18n.locale,
    authed: !!state.user.userData
  }),
  { setLanguage }
)(withRouter(Menu));
